import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';

import { ModalContent, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionPaymentContent',
  props: {
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalContent), {
    class: "transaction-payment-content",
    variant: __props.variant
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["variant"]))
}
}

})